export default __webpack_public_path__ + "static/CharlieDisplay-Semibold-d5c0967c3a83ab95fcee2d6e84c0f13c.otf";